import { render, staticRenderFns } from "./AnamnesisForm.vue?vue&type=template&id=0b874902&scoped=true"
import script from "./AnamnesisForm.vue?vue&type=script&lang=js"
export * from "./AnamnesisForm.vue?vue&type=script&lang=js"
import style0 from "./AnamnesisForm.vue?vue&type=style&index=0&id=0b874902&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b874902",
  null
  
)

export default component.exports